import { useAppContext } from "../../contexts/AppContext";

type EventState = "BEFORE" | "DURING" | "AFTER" | "UNKNOWN";

export const useEventDates = () => {
  const { config } = useAppContext();

  const state: EventState = config?.event.dates
    ? Date.now() < config.event.dates.start
      ? "BEFORE"
      : Date.now() < config.event.dates.end
        ? "DURING"
        : "AFTER"
    : "UNKNOWN";

  if (state === "UNKNOWN" || !config?.event.dates) return { state };

  return {
    state,
    start: config.event.dates.start,
    end: config.event.dates.end,
  };
};
